module.exports = "/_next/static/images/badge-apple-app-store-efaa243a03bf4e51b68b3d2750545a24.svg";